import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { ZoomableImage } from '../ZoomableImage';
import { PROJECT_INCLUDES, TECH_PROOF } from '../../data/catio';

/**
 * Ready-to-build system + real technical proof, in one section.
 * What every project includes → the real pages that prove it.
 */
export function SystemSection() {
  return <section id="system" aria-labelledby="system-title" className="bg-paper py-12 sm:py-20" data-id="element-264" data-mp="3og8odamq8k6m">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-265" data-mp="3t6fbt75i5yna">
        <SectionHeading id="system-title" eyebrow="Every project follows the same ready-to-build system" title="Know What to Buy. Know What to Cut. Know Where It Goes. Know How to Build It." data-id="element-266" data-mp="3t806qxvqbjlo" />

        <ul className="mt-7 grid grid-cols-2 gap-x-4 gap-y-3 border-y border-line py-5 sm:mt-9 sm:grid-cols-4 sm:gap-x-6" data-id="element-267" data-mp="35h4lykpoxonx">
          {PROJECT_INCLUDES.map(item => <li key={item} className="flex items-center gap-2.5 text-[0.92rem] font-semibold text-ink" data-id="element-268" data-mp="3aiacqczsj1ut">
              <CheckIcon className="h-4 w-4 shrink-0 text-wood" strokeWidth={2.5} aria-hidden data-id="element-269" data-mp="bs5as53l7rep" />
              {item}
            </li>)}
        </ul>

        <ul className="mt-9 grid gap-9 sm:mt-12 md:grid-cols-2 md:gap-x-6 md:gap-y-10" data-id="element-270" data-mp="kpo1nq3wwzyi">
          {TECH_PROOF.map(item => {
          const portrait = item.height > item.width;
          return <li key={item.label} className="flex flex-col" data-id="element-271" data-mp="3o88whudvzp9k">
                <h3 className="font-display text-[1.4rem] leading-tight text-ink sm:text-[1.6rem]" data-id="element-272" data-mp="3k646r6qk7cs7">
                  {item.label}
                </h3>
                <p className="label-tech mt-1.5 text-graphite/70" data-id="element-273" data-mp="1tfuggrcaf0k">{item.source}</p>
                <div className="mt-3 flex flex-1 items-center justify-center overflow-hidden rounded-[12px] border border-line bg-paper p-3 shadow-[0_18px_36px_-28px_rgba(28,31,28,0.4)] sm:p-5 md:aspect-[5/4]" data-id="element-274" data-mp="3t5qwuwdu8w5y">
                  <ZoomableImage image={item} className="flex h-full items-center justify-center" imgClassName={`mx-auto object-contain ${portrait ? 'max-h-[440px] w-auto md:h-full md:max-h-none' : 'w-full md:max-h-full'}`} data-id="element-275" data-mp="30hbtj742k2ag" />
                </div>
              </li>;
        })}
        </ul>
        <p className="label-tech mt-6 text-center text-graphite/60 md:hidden" data-id="element-276" data-mp="1j5fq5w57qzbg">
          Tap any image to enlarge
        </p>
      </div>
    </section>;
}